// import React, { Component } from "react"

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

/**
 * Displays notification about succesfull change of password
 */
export const showToast = (message) => {
  // var message = this.props.editSuccessMsg
  //position class
  var positionClass = 'toast-top-right';
  toastr.options = {
    positionClass: positionClass,
    timeOut: 5000,
    extendedTimeOut: 1000,
    closeButton: true,
    behaviorButton: false,
    debug: false,
    progressBar: true,
    preventDuplicates: true,
    newestOnTop: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    showDuration: 300,
    hideDuration: 1000
  };
  toastr.success(message);
};

export const showToastFixed = (message) => {
  // var message = this.props.editSuccessMsg
  //position class
  var positionClass = 'toast-top-right';
  toastr.options = {
    positionClass: positionClass,
    timeOut: 0,
    extendedTimeOut: 0,
    closeButton: false,
    behaviorButton: false,
    debug: false,
    progressBar: false,
    preventDuplicates: true,
    newestOnTop: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
    showDuration: 300,
    hideDuration: 1000
  };
  toastr.info(message);
};
export const clearToast = () => {
  toastr.clear();
};
